import { render, staticRenderFns } from "./Jewel04_Ange.vue?vue&type=template&id=0f4ccf19&scoped=true&"
import script from "./Jewel04_Ange.vue?vue&type=script&lang=js&"
export * from "./Jewel04_Ange.vue?vue&type=script&lang=js&"
import style0 from "./Jewel04_Ange.vue?vue&type=style&index=0&id=0f4ccf19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ccf19",
  null
  
)

export default component.exports